'use client'

import { useFormContext } from 'react-hook-form'

import { cn } from '@/shared/lib/utils'

import { authCtaClassName } from '../../constants/styles'

type ForgotPasswordButtonProps = {
  children?: React.ReactNode
  className?: string
  disabled?: boolean
}

export const ForgotPasswordButton = ({
  children,
  className,
  disabled,
  ...props
}: ForgotPasswordButtonProps) => {
  const { formState } = useFormContext()
  const isSubmitting = formState.isSubmitting

  return (
    <button
      type="submit"
      disabled={isSubmitting || disabled}
      className={cn(authCtaClassName, className)}
      {...props}
    >
      {isSubmitting ? 'Enviando...' : children || 'Enviar código'}
    </button>
  )
}
